/**
 * useProductsPageUi – UI-State-Schicht für /v2/products (S6 Redesign-Shell)
 * Kapselt: channelId, page, search, issueFilter, imageStatusFilter,
 *          selectedIds, drawerProduct, analyzeOpen, packshotPickerOpen
 */
import { useState, useCallback } from 'react'
import type { IssueFilter } from '@/lib/api/channel-readiness'
import type { ProductWithReadiness } from '@/types/products'

export function useProductsPageUi() {
  const [page, setPage] = useState(1)
  const [searchInput, setSearchInput] = useState('')
  const [search, setSearch] = useState('')
  const [channelId, setChannelId] = useState<string | null>(null)
  const [issueFilter, setIssueFilter] = useState<IssueFilter | null>(null)
  const [imageStatusFilter, setImageStatusFilter] = useState<string[]>([])
  const [selectedIds, setSelectedIds] = useState(new Set<string>())
  const [drawerProduct, setDrawerProduct] = useState<ProductWithReadiness | null>(null)
  const [analyzeOpen, setAnalyzeOpen] = useState(false)
  const [packshotPickerOpen, setPackshotPickerOpen] = useState(false)

  const handleSelectChannel = useCallback((id: string) => {
    setChannelId(id); setIssueFilter(null); setImageStatusFilter([]); setPage(1)
  }, [])

  const clearSelection = useCallback(() => setSelectedIds(new Set()), [])

  const onToggleSelect = useCallback((id: string) => {
    setSelectedIds(prev => { const n = new Set(prev); if (n.has(id)) n.delete(id); else n.add(id); return n })
  }, [])

  const handleSearchSubmit = useCallback(() => { setSearch(searchInput); setPage(1) }, [searchInput])

  return {
    page, setPage, searchInput, setSearchInput, search, handleSearchSubmit,
    channelId, setChannelId, handleSelectChannel,
    issueFilter, setIssueFilter, imageStatusFilter, setImageStatusFilter,
    selectedIds, setSelectedIds, clearSelection, onToggleSelect,
    drawerProduct, setDrawerProduct,
    analyzeOpen, setAnalyzeOpen,
    packshotPickerOpen, setPackshotPickerOpen,
  }
}
